import styles from './HBox.module.css';

type HBoxProps = {
    children?: React.ReactNode;
    gap?: number | string;
    className?: string;
    style?: React.CSSProperties;
    stretch?: boolean;
    title?: string;
}

const HBox = ({ children, gap, className, style, stretch, title }: Readonly<HBoxProps>) => {
    return (
        <div title={title} className={[styles.hbox, stretch ? styles.stretch : null, className].join(' ')} style={{ ...(style ?? {}), gap }}>{children}</div>
    )
}

export default HBox;